<section fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="start center"
         fxLayout.gt-xs="row" fxLayoutGap.gt-sx="20px">

  <bb-number number="1"></bb-number>
  <h2 class="txt">I AM A</h2>
  <div fxLayout="row" fxLayoutGap="8px"
       fxLayoutGap.gt-sx="20px">
    <button (click)="control.setValue(EmploymentType.land)"
            [ngClass]="{'active': isLandbased|async}">
      LAND BASED
    </button>
    <button (click)="control.setValue(EmploymentType.sea)"
            [ngClass]="{'active': isSeaman|async}">
      SEAMAN
    </button>
  </div>
  <div class="txt">OFW.</div>

</section>
